export const word={
    "en":{
        "resName":"Restaurant Name",
        "resAddress":"Address",
        "description":"Description",
        "chooseLanguages":"Choose Language",
        "cancel":'Cancel',
        "confirm":'Confirm',
        "save":'Save',
        "menu":'Menu',
        "categoryName":'Category Name',
        "title":'Title',
        "price":'Price',
        "priceUnit":'Price Unit',
    },
    "fa":{
        "resName":"نام رستوران",
        "resAddress":"آدرس",
        "description":"توضیحات",
        "chooseLanguages":"انتخاب زبان",
        "cancel":'انصراف',
        "confirm":'تایید',
        "save":'ذخیره',
        "menu":'منو',
        "categoryName":'نام دسته',
        "title":'عنوان',
        "price":'قیمت',
        "priceUnit":'واحد پول',
    }
};